import React from "react";
import S from "../../../../styles/components";

const Word = ({ value, className, onClick }) => (
  <S.TranscriptWord className={className} onClick={onClick}>
    {value}
  </S.TranscriptWord>
);

export default Word;
